import { Form, Input } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import { usePermissions } from 'business/contextProviders/usePermissions';
import { RingTableFilterData } from 'business/production-and-performance/pages/ring-table';
import {
  useProdAndPerfFilters,
  useProdAndPerfFiltersFormName,
} from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { Module_Enum, useGetCurrentRingQuery } from 'generated/graphql';
import { FilterData } from 'technical/filter-data';
import { SelectedItemsFooter } from 'ui/filter-footer';
import {
  PreselectRingRangeInput,
  PreselectRingRangeTypeEnum,
} from 'ui/form/preselect-ring-range-input';

export const RingsTableFilters = ({
  filterData,
}: {
  filterData: FilterData<RingTableFilterData>;
}) => {
  const { t } = useTranslation();
  const formName = useProdAndPerfFiltersFormName();
  const [form] = Form.useForm();
  const filters = useProdAndPerfFilters();
  const { constructionSiteId } = usePermissions();
  const headers = useGraphqlApiHeaders(Module_Enum.ProdPerf);

  const { data, error } = useGetCurrentRingQuery({
    variables: { constructionSiteId },
    context: {
      headers,
    },
  });

  return (
    <div>
      <Form
        layout="inline"
        form={form}
        name={formName}
        initialValues={{
          filterType: 'ring',
        }}
      >
        {/* Hidden field used to set the filter type to `ring` */}
        <Form.Item name="filterType" hidden>
          <Input disabled />
        </Form.Item>
        <Form.Item name="ringRange" label={t('input.ringRange.label')}>
          <PreselectRingRangeInput
            defaultType={PreselectRingRangeTypeEnum.All}
            lastRing={data?.parameter_ring_aggregate.aggregate?.max?.ringNumber}
            error={!!error}
          />
        </Form.Item>
      </Form>
      {filters.filterType === 'ring' &&
      filters.ringRange?.every((boundary) => boundary === null) &&
      filterData?.selectedRings ? (
        <SelectedItemsFooter mobile>
          {t('productionAndPerformance.ring.selectedRings', {
            selectedRings: filterData?.selectedRings,
          })}
        </SelectedItemsFooter>
      ) : null}
    </div>
  );
};
